import {success} from "./helpers";
export const initialState = {
  client_business_total: [],
  search_results: [],
  all_search_results: [],
  client_users_total: [],
  users_results: [],
  users_all:[],
  all_users_results: []
}
import {
  GET_CLIENT_BUSINESS_TOTAL,
  CLIENT_BUSINESS_SEARCH,
  ALL_SEARCH,
  USERS_SEARCH,
  ALL_USERS_SEARCH,
  USERS_SEARCH_ALL_RESULT,
  CLEAR_USERS_SEARCH
} from '../actions/ClientBusinessInfoAndUser'

export const clientBusinessAndUser = (state=initialState, action) => {
  switch (action.type) {
    case success(GET_CLIENT_BUSINESS_TOTAL):
      let obj = [];
      let $obj = [];
      let len = Object.keys(action.payload)
      let temp = '';
      temp = len[1];
      len[1] = len[2];
      len[2] = temp;
      for (const item of len) {
        let label = '';
        let list = '';
        let $list = '';
        switch (item) {
          case 'totalClients':
            label = 'Total Clients';
            break;
          case 'totalBizUnit':
            label = 'Total Business Units';
            break;
          case 'clientsJoinLastMonth':
            label = 'Joined Last 30 Days';
            break;
          case 'bizUnitJoinLastMonth':
            label = 'Joined Last 30 Days';
            break;
          case 'clientUsers':
            label = 'Client Users';
            break;
          case 'bizUnitUsers':
            label = 'Business Unit Users';
            break;
          default:
            return;
        }
        if (label === 'Client Users' || label === 'Business Unit Users') {
          $list = Object.assign({}, {
            label: `${label}`,
            value: action.payload[item],
            item: item
          });
          $obj.push($list);
        } else {
          list = Object.assign({}, {
            label: `${label}`,
            value: action.payload[item],
            item: item
          });
          obj.push(list);
        }
      }
      return {
        ...state,
        client_business_total: obj,
        client_users_total: $obj
      }
    case success(CLIENT_BUSINESS_SEARCH):
      let filterPayload = {
        ...action.payload
      }
      for (const list of filterPayload.clients.data) {
        for (const id of Object.keys(filterPayload.bizUnits)) {
          if (list.id === parseInt(id, 10)) {
            list['children'] = filterPayload.bizUnits[id];
          }
        }
      }
      return {
        ...state,
        search_results: filterPayload
      }
    case success(USERS_SEARCH):
      let filterP = {
        ...action.payload
      }
      for (const list of filterP.clientUsers.data) {
        for (const id of Object.keys(filterP.bizUnitUsers)) {
          if (list.clientId === parseInt(id, 10)) {
            list['children'] = filterP.bizUnitUsers[id];
          }
        }
      }
      return {
        ...state,
        users_results: filterP
      }
    case CLEAR_USERS_SEARCH:
      return {
        ...state,
        users_results: []
      }
    case success(USERS_SEARCH_ALL_RESULT):
      let filter_all_result = {
        ...action.payload
      }
      for (const list of filter_all_result.clientUsers.data) {
        for (const id of Object.keys(filter_all_result.bizUnitUsers)) {
          if (list.clientId === parseInt(id, 10)) {
            list['children'] = filter_all_result.bizUnitUsers[id];
          }
        }
      }
      return {
        ...state,
        users_all: filter_all_result
      }
    case success(ALL_SEARCH):
      let $filterPayload = {
        ...action.payload
      }
      for (const list of $filterPayload.clients.data) {
        for (const id of Object.keys($filterPayload.bizUnits)) {
          if (list.id === parseInt(id, 10)) {
            list['children'] = $filterPayload.bizUnits[id];
          }
        }
      }
      return {
        ...state,
        all_search_results: $filterPayload
      }
    case success(ALL_USERS_SEARCH):
      let $filterP = {
        ...action.payload
      }
      for (const list of $filterP.clientUsers.data) {
        for (const id of Object.keys($filterP.bizUnitUsers)) {
          if (list.clientId === parseInt(id, 10)) {
            list['children'] = $filterP.bizUnitUsers[id];
          }
        }
      }
      return {
        ...state,
        all_users_results: $filterP
      }
    default:
      return state;
  }
}

export default {
  clientBusinessAndUser
};


// WEBPACK FOOTER //
// ./src/reducers/clientBusinessAndUser.js